import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalexperiencevoice-card',
  templateUrl: './helpbutton-reports-totalexperiencevoice-card.component.html',
  styleUrls: ['./helpbutton-reports-totalexperiencevoice-card.component.scss']
})
export class HelpbuttonReportsTotalexperiencevoiceCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
